export default __webpack_public_path__ + "static/media/refrigerator.5381e28c.png";